import { parseJsonField } from "../../utils/parseJsonField";
import "../../css/pageLayout.css"

function CardsSection({ section }) {
  const settings = parseJsonField(section.settings_json);
  const items = section.items || [];
  const columns = settings.columns || 3;

  return (
    <section className="cards-section">
      {settings.title && <h2>{settings.title}</h2>}

      <div
        className="cards-grid"
        style={{
          gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`
        }}
      >
        {items
          .filter((item) => item.is_visible !== false)
          .map((item) => {
            const content = parseJsonField(item.content_json);

            return (
              <article className="card-item" key={item.id}>
                {content.image_url && (
                  <img src={content.image_url} alt={content.title || ""} />
                )}

                {content.title && <h3>{content.title}</h3>}
                {content.text && <p>{content.text}</p>}

                {content.button_text && content.button_url && (
                  <a href={content.button_url} className="card-button">
                    {content.button_text}
                  </a>
                )}
              </article>
            );
          })}
      </div>
    </section>
  );
}

export default CardsSection;